import { useState } from 'react';
import useDidMountEffect from "./useDidMountEffect";
import {useDealContext} from "../contexts/DealContext";
import {toast} from "react-toastify";
import {rebateIdHelper} from "../utils/utils";

const useRebateStateHook = (rebate) => {
    const { dealState, setDealStateWithUpdate, updateDealResponse } = useDealContext()
    const [rebateState, setRebateState] = useState(rebate)

    const setRebateStateWithUpdate = (newState, update = true) => {
        return setRebateState({...rebateState, ...newState, _update: update})
    }

    useDidMountEffect(function updateFeeFromBackend(){
        setRebateState({...rebate, _update: false})
    }, [])

    useDidMountEffect(function updateDealState(){
        if (rebateState) {
            let newDealState = structuredClone(dealState)
            let allRebates = newDealState.formatted_quote.rebates

            allRebates.forEach((el, index, array) => {
                if (rebateIdHelper(rebateState) === rebateIdHelper(el)) {
                    array[index] = rebateState
                }
            })

            newDealState.formatted_quote.rebates = allRebates
            setDealStateWithUpdate(newDealState, rebateState?._update)
        }
    }, [rebateState])

    useDidMountEffect(function updateRebateFromBackend(){
        if (
            updateDealResponse?.data?.data &&
            !updateDealResponse.loading &&
            !updateDealResponse.error &&
            rebateState
        ) {
            const newDealState = updateDealResponse?.data?.data

            const rebateFromBackend = newDealState.formatted_quote.rebates.find(r => rebateIdHelper(r) === rebateIdHelper(rebate))

            if (rebateFromBackend) {
                if (rebateState.is_applied && !rebateFromBackend.is_applied) {
                    toast.warn(`Rebate ${rebateState.name} is not compatible with currently applied rebates.`)
                }
                setRebateState({...rebateFromBackend, _update: false})
            }
        }
    }, [updateDealResponse])


    return [rebateState, setRebateStateWithUpdate]
}

export default useRebateStateHook;